import {gql, useQuery} from '@apollo/client';
import {
  AccountStatuses,
  AccountStatusesVariables,
} from '../../schema-types/AccountStatuses';
import {ATR_FRAGMENT} from '../../graphql/fragments';
import validateUUID from '../../utils/validateUUID';

export const useContactStatuses = (accountId: string) => {
  const {data: contactStatuses, loading: contactStatusesLoading} = useQuery<
    AccountStatuses,
    AccountStatusesVariables
  >(CONTACT_STATUSES, {
    variables: {
      accountId: validateUUID(accountId)!,
    },
  });
  return {
    contactStatuses,
    contactStatusesLoading,
  };
};
export const CONTACT_STATUSES = gql`
  query AccountStatuses($accountId: UUID!) {
    accountDetails(accountId: $accountId) {
      id
      primaryContact {
        id
        simplifiedName
        atr {
          ...AtrFragment
        }
      }
      secondaryContact {
        id
        simplifiedName
        atr {
          ...AtrFragment
        }
      }
    }
  }
  ${ATR_FRAGMENT}
`;
